module.exports = __webpack_public_path__ + "static/media/fontarabic.5f8af29d.ttf";